<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wmXzd3/tc-custom/9781467467766.jpg?1725592375012" alt="This image is the cover for the book Behind the Smile"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Behind the Smile
      </h1>
      <p class="bookDescription body article font2">
        <b>Doug Meijer reveals the real challenges he’s faced and the life lessons he learned along the way. </b><br/>  <br/> Doug Meijer is best known as the cochairman of the superstore chain Meijer. In this candid memoir, he pulls back the curtain on his seemingly happy image to share his struggles with family, work, and health—and what they taught him about life. <br/>  <br/> Within one week in November 2011, Doug’s marriage ended, his father passed away, and he was diagnosed with cancer. Alongside these crises, he struggled with intensifying depression leading eventually to treatment at an inpatient program. As he has healed, he’s come to realize some straightforward wisdom: There is no secret to survival. Ask for help. Practice gratitude.  <br/>  <br/> In addition to sharing the challenges he’s faced, Doug also tells the story of how he left behind his athletic aspirations to follow in his father’s footsteps. Through the family business, he found purpose and meaning through philanthropy.  <br/>  <br/> But <i>Behind the Smile</i> isn’t about what it takes to succeed in business. It’s about the problems that can affect any of us and how one man has persisted through them. With refreshing vulnerability and warmth, Doug extends a hand of empathy and a message of hope for healing and wholeness.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Doug Meijer
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Douglas Meijer</B>&#160;is a philanthropist and former cochairman of the US supermarket chain Meijer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73d73474